export enum BoardRoleEnum {
  Owner = 1,
  Member = 2,
}
